export default function shallowEquals(a: object, b: object, ignoreFunctions: boolean = false) {
  for (const p in a) {
    if (!(p in b)) {
      return false;
    }
  }
  for (const p in b) {
    if (ignoreFunctions && typeof a[p] === 'function' && typeof b[p] === 'function') {
      continue;
    }
    if (!(p in a) || a[p] !== b[p]) {
      return false;
    }
  }
  return true;
}
